
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/2024/speakers",
      function () {
        return require("private-next-pages/sa/2024/speakers.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/2024/speakers"])
      });
    }
  